<template>
    <div class="register">
        <van-nav-bar
                title="注册新用户"
                left-arrow
                :fixed="true"
                class="my-nav"
                @click-left="$router.back(-1)"
                :z-index="100"
        />
        <div class="card">
            <div class="card-header" style="display: flex; justify-content: space-between;padding-right: 10px;">
                <div>1.客户信息</div>
                <a href="javascript:void(0);" @click="showDialog=true">驳回客户修改信息></a>
            </div>
            <van-cell-group>
                <van-field label="客户名称" v-model="params.shopName" required placeholder="请输入客户名称"/>
                <van-field label="月度容量" v-model="params.monthCount" required placeholder="请输入月度容量" type="number"/>
                <van-field label="注册地址" v-model="params.shopAddress" required placeholder="请输入注册地址"/>
                <van-field label="设置密码" v-model="params.password" required type="password" placeholder="请输入设置密码"
                           @blur="verifyPassword"/>
                <van-field label="确认密码" v-model="params.confirmPassword" required type="password" placeholder="请输入确认密码"
                           @blur="verifyConfirmPassword"/>
                <van-field label="电话号码" v-model="params.phone" required placeholder="请输入登录手机号码" type="number"/>
                <span style="color: #ed3f14;font-size: 12px;margin-left: 10px">*此手机号为登录手机号，并且接收支付短信验证码</span>
                <van-cell-group>
                    <van-cell title="是否异业渠道">
                        <van-radio-group v-model="params.yiye" direction="horizontal">
                            <van-radio name="true">是</van-radio>
                            <van-radio name="false">否</van-radio>
                        </van-radio-group>
                    </van-cell>
                    <van-cell title="是否家电渠道">
                        <van-radio-group v-model="params.jiadian" direction="horizontal">
                            <van-radio name="true">是</van-radio>
                            <van-radio name="false">否</van-radio>
                        </van-radio-group>
                    </van-cell>
                </van-cell-group>
                <van-uploader v-model="img.shopPhotos"
                              :max-count="1"
                              style="padding: 10px"
                              :before-read="beforeRead"
                              :max-size=5242880
                              @oversize="ifOversize"
                              accept="image/gif, image/jpeg ,image/png"
                              :after-read="afterReadShopPhoto"
                >
                    <van-button icon="photo" style="background-color:#3399FF;color: #fff;">上传门头照片</van-button>
                </van-uploader>
            </van-cell-group>
            <div class="card-header">
                2.法人基本信息 <span style="font-size: 12px">(暂时只支持中国大陆居民身份证)</span>
            </div>
            <van-cell-group>
                <van-field label="法人" v-model="params.personInCharge" required placeholder="请输入法人名称"/>
                <van-field label="法人身份证号" v-model="params.personInChargeNo" required placeholder="请输入法人身份证号" @blur="verifyPersonInChargeNo"/>
                <van-field label="邮箱" v-model="params.mailbox" required placeholder="请输入法人邮箱" @blur="verifyMailbox"/>
                <van-uploader
                        v-model="img.idCardFront"
                        :max-count="1"
                        style="padding: 10px"
                        :before-read="beforeRead"
                        :max-size=5242880
                        @oversize="ifOversize"
                        accept="image/gif, image/jpeg ,image/png"
                        :after-read="afterReadIdCardFront"
                >
                    <van-button icon="photo" style="background-color:#3399FF;color: #fff;"> *点击上传法人身份证头像面</van-button>
                </van-uploader>
                <br>
                <van-uploader
                        v-model="img.idCardReverse"
                        :max-count="1"
                        style="padding: 10px"
                        :before-read="beforeRead"
                        :max-size=5242880
                        @oversize="ifOversize"
                        accept="image/gif, image/jpeg ,image/png"
                        :after-read="afterReadIdCardReverse"
                >
                    <van-button icon="photo" style="background-color:#3399FF;color: #fff;">*点击上传法人身份证国徽面</van-button>
                </van-uploader>
            </van-cell-group>


            <div class="card-header">
                3.操盘手基本信息<span style="font-size: 12px">(暂时只支持中国大陆居民身份证)</span>
            </div>
            <van-cell-group>
                <van-field label="操盘手" v-model="params.trader" required placeholder="请输入操盘手名称"/>
                <van-field label="电话号码" v-model="params.traderPhone" required placeholder="请输入操盘手电话号码" type="number"/>
            </van-cell-group>

            <div class="card-header">
                4.营业执照信息<span style="font-size: 12px">(需提供开店人与经营者姓名一致的个体工商户营业执照)</span>
            </div>
            <van-cell-group>
                <van-field label="统一社会信用代码" v-model="params.creditCode" required placeholder="请输入社会信用代码"/>
                <van-cell-group>
                    <van-cell is-link title="营业期限" required v-model="params.termOfOperation"
                              @click="currentDateShow = true"/>
                    <van-popup v-model="currentDateShow" position="bottom">
                        <van-datetime-picker
                                @change="onChangeDate"
                                type="date"
                                @confirm="currentDateShow = false"
                                @cancel="currentDateShow = false"

                        />
                    </van-popup>
                    <van-cell>
                        <span style="float: left;margin-right: 10px">至</span>
                        <van-checkbox v-model="params.longTime" style="float: left">长期</van-checkbox>
                    </van-cell>
                </van-cell-group>
                <van-uploader
                        v-model="img.businessLicense"
                        :max-count="1"
                        style="padding: 10px"
                        :before-read="beforeRead"
                        :max-size=5242880
                        @oversize="ifOversize"
                        accept="image/gif, image/jpeg ,image/png"
                        :after-read="afterReadBusinessLicense"
                >
                    <van-button icon="photo" style="background-color:#3399FF;color: #fff;">*点击上传营业执照</van-button>
                </van-uploader>
            </van-cell-group>


            <div class="card-header">
                5.收货地址信息 <span style="font-size: 12px">(请和加盖公章文件一致)</span>
            </div>
            <van-cell-group>
                <van-field label="姓名" v-model="params.receiveName" required placeholder="请输入收货人姓名"/>
                <van-field label="电话" v-model="params.receivePhone" required placeholder="请输入收货人电话" type="number"/>
                <van-uploader
                        v-model="img.receiveIdCardFront"
                        :max-count="1"
                        style="padding: 10px"
                        :before-read="beforeRead"
                        :max-size=5242880
                        @oversize="ifOversize"
                        accept="image/gif, image/jpeg ,image/png"
                        :after-read="afterReadReceiveIdCardFront"
                >
                    <van-button icon="photo" style="background-color:#3399FF;color: #fff;"> *点击上传收货人身份证头像面</van-button>
                </van-uploader>
                <br>
                <van-uploader
                        v-model="img.receiveIdCardReverse"
                        :max-count="1"
                        style="padding: 10px"
                        :before-read="beforeRead"
                        :max-size=5242880
                        @oversize="ifOversize"
                        accept="image/gif, image/jpeg ,image/png"
                        :after-read="afterReadReceiveIdCardReverse"
                >
                    <van-button icon="photo" style="background-color:#3399FF;color: #fff;">*点击上传收货人身份证国徽面</van-button>
                </van-uploader>
                <van-cell-group>
                    <van-cell is-link v-model="params.address" title="省/市/区" value="请选择" @click="openAddress('address')"
                              required></van-cell>

                </van-cell-group>

                <van-field label="详细地址" v-model="params.addressDetails" required placeholder="请输入详细收货地址"/>
                <van-cell>
                    <a style="color: #2d8cf0;font-size: 14px;"
                       href="https://image-jinyijia1688-com.oss-cn-beijing.aliyuncs.com/file/%E6%94%B6%E8%B4%A7%E4%BF%A1%E6%81%AF%E6%8E%88%E6%9D%83%E5%87%BD.jpg">
                        点击下载金怡华地址模板 </a>
                </van-cell>
                <van-cell>
                    <a style="color: #2d8cf0;font-size: 14px;"
                       href="https://image-jinyijia1688-com.oss-cn-beijing.aliyuncs.com/file/%E6%8E%88%E6%9D%83%E5%A7%94%E6%89%98%E4%B9%A6.doc">
                        点击下载新松联地址模板 </a>
                </van-cell>
                <van-cell>
                    <a style="color: #2d8cf0;font-size: 14px;"
                       href="http://image-jinyijia1688-com.oss-cn-beijing.aliyuncs.com/file/%E8%89%BE%E5%90%89%E5%A7%86%E6%8E%88%E6%9D%83%E5%A7%94%E6%89%98%E4%B9%A6.doc">
                        点击下载艾吉姆地址模板 </a>
                </van-cell>
                <van-cell>
                    <a style="color: #2d8cf0;font-size: 14px;"
                       href="http://m.jinyijia1688.com/file/%E9%B8%BF%E7%B1%B3%E6%8E%88%E6%9D%83%E5%A7%94%E6%89%98%E4%B9%A6.doc">
                        点击下载鸿米地址模板 </a>
                </van-cell>
                <van-cell>
                    <a style="color: #2d8cf0;font-size: 14px;"
                       href="http://image-jinyijia1688-com.oss-cn-beijing.aliyuncs.com/file/%E6%8E%88%E6%9D%83%E5%A7%94%E6%89%98%E4%B9%A6-%E5%B1%B1%E4%B8%9C%E6%88%B4%E9%9D%A9%E9%80%9A%E4%BF%A1%E8%AE%BE%E5%A4%87%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8.doc">
                        点击下载戴革地址模板 </a>
                </van-cell>
                <van-uploader v-model="img.receiveAddress"
                              :max-count="1"
                              style="padding: 10px"
                              :before-read="beforeRead"
                              :max-size=5242880
                              @oversize="ifOversize"
                              accept="image/gif, image/jpeg ,image/png"
                              :after-read="afterReadReceiveAddress"
                >
                    <van-button icon="photo" style="background-color:#3399FF;color: #fff;">*点击上传加盖公章的收货地址图片</van-button>
                </van-uploader>
            </van-cell-group>
          <div class="card-header">
            6.开票信息
          </div>
          <van-cell-group>
            <van-field label="纳税人识别号" v-model="params.taxpayerIdNumber" required placeholder="请输入纳税人识别号"/>
            <van-field label="税务登记地址 " :value="params.taxAddressTexT" required placeholder="请选择税务登记地址" is-link  @click="openAddress('taxAddressTexT')"/>
            <van-field label="税务登记详细地址 " v-model="params.taxAddressDetails" required placeholder="请输入税务登记详细地址"/>
            <van-field label="联系电话 " v-model="params.taxTelPhone" required placeholder="请输入联系电话" type="number"/>
            <van-field label="开户行 " v-model="params.bankOfDeposit" required placeholder="请输入开户行" />
            <van-field label="开户账号 " v-model="params.bankAccountNo" required placeholder="请输入开户账号" />
          </van-cell-group>
            <div style="padding: 10px 0;">
                <van-checkbox v-model="checked" style="float: left"></van-checkbox>
                <span style="color: #5f5f5f;float: left;margin-left: 5px"> 我已阅读并同意<a href="javascript:void(0);"
                                                                                     @click="agreeDialog"
                                                                                    ><span
                        style="color: #3399FF">《用户注册协议》</span></a></span>
            </div>

        </div>
        <van-button :disabled="!checked" type="danger" block style="margin-top: 20px; z-index: 101" @click="register">注册
        </van-button>

        <van-dialog
                v-model="showDialog"
                title="驳回客户修改信息"
                show-cancel-button
                @confirm="searchStores"
        >
            <van-field v-model="phone" placeholder="请输入驳回客户手机号"/>
        </van-dialog>
      <van-popup v-model="show" position="bottom">
        <van-area
            ref="area"
            :area-list="areaList"
            @change="onChange"
            @confirm="show = false"
            @cancel="show = false"
        />
      </van-popup>
    </div>
</template>

<script>
    import {Toast} from 'vant'
    import {Dialog} from 'vant'
    import {regionList, upload, addStoreRegistered, findByPhone} from '../../api/login/register'

    export default {
        data() {
            return {
                checked: false,
                show: false,
                areaList: {},
                currentDateShow: false,
                showDialog: false,
                phone: undefined,
                addressField:'address',
                img: {
                    shopPhotos: [],
                    idCardFront: [],
                    idCardReverse: [],
                    businessLicense: [],
                    receiveIdCardFront: [],
                    receiveIdCardReverse: [],
                    receiveAddress: []
                },
                params: {
                    shopName: undefined,
                    monthCount: undefined,
                    shopAddress: undefined,
                    shopPhotoPath: undefined,
                    password: undefined,
                    confirmPassword: undefined,
                    phone: undefined,
                    personInCharge: undefined,
                    personInChargeNo: undefined,
                    mailbox: undefined,
                    idCardFrontPath: undefined,
                    idCardReversePath: undefined,
                    trader: undefined,
                    traderPhone: undefined,
                    creditCode: undefined,
                    termOfOperation: undefined,
                    longTime: true,
                    businessLicense: undefined,
                    receiveName: undefined,
                    receivePhone: undefined,
                    receiveIdCardFrontPath: undefined,//TODO this.receiveIdCardFrontPath,
                    receiveIdCardReversePath: undefined,//TODO this.receiveIdCardReversePath,
                    address: undefined,//TODO  this.addressArray,
                    addressDetails: undefined,
                    receiveAddress: undefined,
                    yiye:'false',
                    jiadian:'false',
                  "taxpayerIdNumber": "",
                  "taxAddressProvince": "",
                  "taxAddressCity": "",
                  "taxAddressDistrict": "",
                  "taxAddressDetails": "",
                  "taxTelPhone": "",
                  "bankOfDeposit": "",
                  "bankAccountNo": "",
                }
            }
        },
        mounted() {
            this.initRegionList()
        },
        methods: {
            initRegionList() {
                regionList(d => {
                    this.areaList = d;
                })
            },
            searchStores() {
                findByPhone(this.phone, res => {
                    delete res.new
                    this.showDialog = false
                    this.params = res
                    if(res.yiye == true){
                        this.params.yiye = "true"
                    }else {
                        this.params.yiye = "false"
                    }
                    if(res.jiadian == true){
                        this.params.jiadian = "true"
                    }else {
                        this.params.jiadian = "false"
                    }
                    if(res.address){
                        this.params.address = res.address.join(',')
                    }

                    this.img.shopPhotos = res.shopPhotoPath ? [{url: res.shopPhotoPath}] : []
                    this.img.idCardFront = res.idCardFrontPath ? [{url: res.idCardFrontPath}] : []
                    this.img.idCardReverse = res.idCardReversePath ? [{url: res.idCardReversePath}] : []
                    this.img.businessLicense = res.businessLicense ? [{url: res.businessLicense}] : []
                    this.img.receiveIdCardFront = res.receiveIdCardFrontPath ? [{url: res.receiveIdCardFrontPath}] : []
                    this.img.receiveIdCardReverse = res.receiveIdCardReversePath ? [{url: res.receiveIdCardReversePath}] : []
                    this.img.receiveAddress = res.receiveAddress ? [{url: res.receiveAddress}] : []
                }, err => {
                    Toast(err);
                    this.showDialog = false
                })
            },
            verifyPassword() {
                if (this.params.password.length < 6) {
                    Toast('设置密码不能少于6位数');
                    return;
                }
            },
            verifyConfirmPassword() {
                if (this.params.confirmPassword.length < 6) {
                    Toast('确认密码不能少于6位数');
                    return;
                }
                if (this.params.password != this.params.confirmPassword) {
                    Toast('两次密码不一致,请重新输入');
                    return;
                }

            },
            verifyPersonInChargeNo() {
                   let personInChargeNo = this.params.personInChargeNo;
                                 let reg = /^(\d{17}|\d{14})[\dx]$/;
                                 if (!reg.test(personInChargeNo)) {
                                     Toast("身份证格式不正确");
                                     return;
                                 }
            },
            verifyMailbox() {
             let email = this.params.mailbox;
                // eslint-disable-next-line no-useless-escape
             let reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
                 if (!reg.test(email)) {
                 Toast("邮箱格式不正确");
                 return;
             }
            },
            register() {
                let params = Object.assign({}, this.params)
                let formErrorMsg = {
                    shopName: '客户名称不能为空',
                    monthCount: '月度容量不能为空',
                    shopAddress: '注册地址不能为空',
                    password: '设置密码不能为空',
                    confirmPassword: '确认密码不能为空',
                    phone: '登陆手机号码不能为空',
                    personInCharge: '法人不能为空',
                    personInChargeNo: '法人身份证号不能为空',
                    mailbox: '法人邮箱不能为空',
                    idCardFrontPath: '请上传法人身份证头像面',
                    idCardReversePath: '请上传法人身份证国徽面',
                    trader: '操盘手不能为空',
                    traderPhone: '操盘手电话不能为空',
                    creditCode: '统一社会信用代码不能为空',
                    termOfOperation: '营业期限不能为空',
                    longTime: '长期',
                    businessLicense: '请上传营业执照',
                    receiveName: '收货人姓名不能为空',
                    receivePhone: '收货人电话不能为空',
                    receiveIdCardFrontPath: '请上传收货人身份证头像面',
                    receiveIdCardReversePath: '请上传收货人身份证头像面',
                    address: '收货人省市区不能为空',
                    addressDetails: '收货人详细地址不能为空',
                    receiveAddress: '请上传加盖公章的收货地址图片',
                    yiye: '请选择是否异业渠道',
                    jiadian: '请选择是否家电渠道',
                    taxpayerIdNumber:'请填写纳税人识别号',
                    taxAddressProvince:'请填写税务登记地址',
                    taxAddressDetails:'请填写税务登记详细地址',
                    taxTelPhone:'请填写开票信息联系电话',
                    bankOfDeposit:'请填写开户行',
                    bankAccountNo:'请填写开户账号'
                }
                if (params.password && params.confirmPassword){
                    if (params.password.length < 6) {
                        Toast('设置密码不能少于6位数');
                        return;
                    }
                    if (params.confirmPassword.length < 6) {
                        Toast('确认密码不能少于6位数');
                        return;
                    }
                    if (params.password != params.confirmPassword) {
                        Toast('两次密码不一致,请重新输入');
                        return;
                    }
                }

                for (let k in params) {
                    // 非必填错误不提示
                    if(!formErrorMsg[k]){
                        continue;
                    }
                    if (!params[k]) {
                        let msg = formErrorMsg[k];
                        if (msg) {
                            Toast(msg);
                            return;
                        }
                    }
                    console.log(k)
                    if (params[k].length == 0) {
                        let msg = formErrorMsg[k];
                        if (msg) {
                            Toast(msg);
                            return;
                        }
                    }
                }

                if (this.checked == false) {
                    Toast('请勾选用户注册协议');
                    return
                }
                params.shopName = (params.shopName).trim();
                params.traderPhone = params.traderPhone.trim()
                params.phone = params.phone.trim()
                params.address = params.address.split(',')
                addStoreRegistered(params, d => {
                    Toast.success("店铺注册成功,请等待审核.");
                    setTimeout(() => {
                        this.$router.push('login')
                    }, 2000)

                }, e => {
                    console.log(e)
                    Toast.fail(e);
                })

            },
            onChangeDate(e) {
                let timeStr = e.getValues();
                this.params.termOfOperation = timeStr[0] + '-' + timeStr[1] + '-' + timeStr[2] + ' 00:00:00'
            },
            onChange(picker, value, index) {
              this.params[this.addressField] = value[0].name + ',' + value[1].name + ',' + value[2].name
              if(this.addressField=='taxAddressTexT'){
                this.params.taxAddressProvince= value[0].name
                this.params.taxAddressCity = value[1].name
                this.params.taxAddressDistrict = value[2].name
              }

            },
            openAddress(addressField){
              this.addressField=addressField
              this.show = true
            },
            beforeRead(file) {
                if (file.type == 'image/jpeg' || file.type == 'image/png') {
                    return true;
                } else {
                    Toast('请上传 jpg或png 格式图片');
                    return false;
                }
            },
            ifOversize() {
                Toast('文件太大了,不能超过5M.');
            },
            afterReadShopPhoto(file) {
                // 此时可以自行将文件上传至服务器
                this.uploadFile(file, imgUrl => {
                    this.params.shopPhotoPath = imgUrl;
                    Toast('门头照片上传成功');
                })
            },
            afterReadIdCardFront(file) {
                this.uploadFile(file, imgUrl => {
                    this.params.idCardFrontPath = imgUrl;
                    Toast('身份证头像面上传成功');
                })
            },
            afterReadIdCardReverse(file) {
                this.uploadFile(file, imgUrl => {
                    this.params.idCardReversePath = imgUrl;
                    Toast('身份证国徽面上传成功');
                })
            },
            afterReadBusinessLicense(file) {
                this.uploadFile(file, imgUrl => {
                    this.params.businessLicense = imgUrl;
                    Toast('营业执照上传成功');
                })
            },
            afterReadReceiveIdCardFront(file) {
                this.uploadFile(file, imgUrl => {
                    this.params.receiveIdCardFrontPath = imgUrl;
                    Toast('收货人身份证头像面上传成功');
                })
            },
            afterReadReceiveIdCardReverse(file) {
                this.uploadFile(file, imgUrl => {
                    this.params.receiveIdCardReversePath = imgUrl;
                    Toast('收货人身份证国徽面上传成功');
                })
            },
            afterReadReceiveAddress(file) {
                this.uploadFile(file, imgUrl => {
                    this.params.receiveAddress = imgUrl;
                    Toast('收货地址图片上传成功');
                })
            },
            uploadFile(file, cb) {
                if (file) {
                    let params = new FormData();
                    params.append("file", file.file);
                    upload(params, imgUrl => {
                        cb(imgUrl.url)
                    }, () => {
                        Toast('上传图片失败')
                    })
                } else {
                    Toast('请上传图片')
                }
            },
            agreeDialog() {
                Dialog.confirm({
                    title: '金怡佳商城注册协议',
                    message:
                        '<h5>一、总则</h5>' +
                        '<p>注册用户在使用金怡佳商城平台提供的各项服务之前，应仔细阅读本服务协议。如您不同意本服务协议及/或随时对其的修改，您可以主动取消金怡佳商城平台提供的服务；您一旦使用金怡佳商城平台的服务，即视为您已了解并完全同意本服务协议各项内容。</p>' +
                        '<h5>二、信息和隐私保护</h5>' +
                        '<p>1  注册用户账户的所有权归金怡佳商城平台，用户完成注册申请手续后，获得金怡佳商城平台帐号的使用权。</p>' +
                        '<p>2  注册用户应提供及时、详尽及准确的企业资料，并不断更新供应商资料。金怡佳商城平台应确保所填报资料的准确性，并对其负责。如因信息不真实而引发问题，则承担问题发生所带来的全部后果。</p>' +
                        '<p>3  注册用户不应将其帐号、密码转让或出借予他人使用。如注册用户发现其帐号遭他人非法使用，应立即通知金怡佳商城平台。因黑客行为或用户的保管疏忽导致帐号、密码遭他人非法使用，金怡佳商城平台不承担任何责任。</p>' +
                        '<p>4  注册用户注册成功后需绑定用户自己或门店对公账户的银行卡方可进行下单，如因绑卡非本人操作、银行卡信息错误、绑定他人银行卡造成的用户损失，由用户自行承担，如因此造成金怡佳货品、财产损失，金怡佳有权追究其法律责任。</p>' +
                        '<p>5  金怡佳商城平台不对外公开或向第三方提供用户的资料。</p>' +
                        '<h5>三、使用规则</h5>' +
                        '<p>1  注册用户在使用金怡佳商城平台的服务时，必须遵守中华人民共和国相关法律法规的规定，注册用户应同意将不会利用本服务进行任何违法或不正当的活动，包括但不限于下列行为∶</p>' +
                        '<p>（1）上载、展示、张贴、传播或以其它方式传送含有下列内容之一的信息：</p>' +
                        '<p>   ① 反对宪法所确定的基本原则的；</p>' +
                        '<p>   ② 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>' +
                        '<p>   ③ 损害国家荣誉和利益的； </p>' +
                        '<p>   ④ 煽动民族仇恨、民族歧视、破坏民族团结的； </p>' +
                        '<p>   ⑤ 破坏国家宗教政策，宣扬邪 教和封建迷信的； </p>' +
                        '<p>   ⑥ 散布谣言，扰乱社会秩序，破坏社会稳定的；</p>' +
                        '<p>   ⑦ 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的； </p>' +
                        '<p>   ⑧ 侮辱或者诽谤他人，侵害他人合法权利的； </p>' +
                        '<p>   ⑨ 含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容； </p>' +
                        '<p>   ⑩ 含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的；</p>' +
                        '<p>（2）不得为任何非法目的而使用网络服务系统；</p>' +
                        '<p>（3）不利用金怡佳商城平台的服务从事以下活动：</p>' +
                        '<p>  ① 未经允许，进入计算机信息网络或者使用计算机信息网络资源的；</p>' +
                        '<p>  ② 未经允许，对计算机信息网络功能进行删除、修改或者增加的；</p>' +
                        '<p>  ③ 未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；</p>' +
                        '<p>  ④ 故意制作、传播计算机病毒等破坏性程序的; </p>' +
                        '<p>  ⑤ 其他危害计算机信息网络安全的行为。</p>' +
                        '<p>2  用户违反本协议或相关的服务条款的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，注册用户同意赔偿金怡佳商城平台与合作公司、关联公司，并使之免受损害。对此，金怡佳商城平台有权视用户的行为性质，采取包括但不限于删除供应商发布信息内容、暂停使用许可、终止服务、限制使用、回收供应商帐号、追究法律责任等措施。对恶意注册帐号或利用注册账户帐号进行违法活动、捣乱、骚扰、欺骗、其他用户以及其他违反本协议的行为，金怡佳商城平台有权回收其帐号。同时，金怡佳商城平台会视司法部门的要求，协助调查。</p>' +
                        '<p>3  注册用户须对自己在使用平台服务过程中的行为承担法律责任。注册用户承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在金怡佳商城平台首先承担了因用户行为导致的行政处罚或侵权损害赔偿责任后，用户应给予金怡佳商城平台等额的赔偿。</p>'

                }).then(() => {

                }).catch(() => {
                    // on cancel
                });
            }

        },
    }
</script>

<style lang="less" scoped>
    .card {
        margin-top: 60px;
        margin-left: 10px;
    }

    .card-header {
        padding: 10px 0 10px 5px;
    }

</style>
<style>
    .van-icon-clear:before {
        content: "";
    }

    .van-dialog__message {
        max-height: 60vh;
        padding: 24px;
        overflow-y: auto;
        font-size: 14px;
        line-height: 20px;
        white-space: pre-wrap;
        text-align: left;
        word-wrap: break-word;
        -webkit-overflow-scrolling: touch;
    }
</style>
